import {Component} from "@angular/core";

import {AppController} from "../AppController";

@Component({
  selector: "app-billing-address-page",
  templateUrl: "./BillingAddressPage.html"
})
export class BillingAddressPage {

  public constructor(private readonly _appController: AppController) {}

  public get appController() {
    return this._appController;
  }

  public get organization() {
    return this.appController.organization;
  }

  public get availableCountries() {
    return this.appController.availableCountries;
  }

}
